/**
 * Слот `search.providers` (module-contract.md, розд. 5.8): групи записів у палітрі `Ctrl+K`.
 * Провайдер шукає сам (запит до свого API), палітра лише викликає його з дебаунсом, скасовує
 * попередній запит і відкидає відповідь, що запізнилась (UX-10). Записи платформи (`POST
 * /api/v1/search`, E5-W6) палітра шукає сама, без слоту (`records-search.ts`); поле вебманіфесту для
 * провайдерів модулів з'явиться окремо (зміна контракту — рев'ю Архітектора).
 */

export interface SearchHit {
  id: string;
  /** Назва запису. */
  label: string;
  /** Другий рядок: телефон, компанія, хто веде — уже відформатовані. */
  sub?: readonly string[];
  /** Адреса в застосунку: `Enter` — перехід, `Ctrl+Enter` / `⌘↩` — нова вкладка. */
  href: string;
  /** Запис без доступу: рядок без даних, не відкривається (states.md, розд. 4). */
  locked?: boolean;
  /** `false` — знайдено поза списком людини (ADR-0010, розд. 3): позначка «Не у вашому списку». */
  inList?: boolean;
}

export interface SearchProvider {
  /** `<модуль>.<група>`, унікальний. */
  id: string;
  /** Заголовок групи результатів («Контакти»). */
  label: string;
  /** З якої довжини запиту шукати (типово 2). */
  minLength?: number;
  /** Помилка — група показує «Пошук недоступний» і «Ще раз»; команди працюють далі. */
  search: (query: string, signal: AbortSignal) => Promise<readonly SearchHit[]>;
}

const providers = new Map<string, SearchProvider>();

/** Додає провайдера; повертає функцію, що його прибирає. */
export function registerSearchProvider(provider: SearchProvider): () => void {
  providers.set(provider.id, provider);
  return () => {
    if (providers.get(provider.id) === provider) providers.delete(provider.id);
  };
}

export const searchProviders = (): readonly SearchProvider[] => [...providers.values()];
